

























import Vue from 'vue';
import { ZenEllipsis } from 'zenComponents';

// TODO: should we instead handle list as separate presenter?
export default Vue.extend({
  name: 'ObjectCellPresenter',
  components: {
    ZenEllipsis,
  },
  computed: {
    objects() {
      /**
       * The data in $attrs can have different shapes:
       *
       * Shape 1: Direct object data
       * data: {
       *   id: ...,
       *   title: ...,
       * }
       *
       * Shape 2: Object data in value
       * data: {
       *   value: {
       *     id: ...,
       *     title: ...,
       *   }
       * }
       *
       * Shape 3: Multiple objects data in value (edges)
       * data: {
       *   value: {
       *     edges: [{
       *       id: ...,
       *       title: ...,
       *     }]
       *   }
       * }
       *
       * Shape 4: Multiple objects data (edges)
       * data: {
       *   edges: [{
       *     id: ...,
       *     title: ...,
       *   }]
       * }
       *
       * Shape 5: Object data in value
       * data: {
       *   objectType: ...,
       *   title: ...,
       * }
       */

      if (!this.$attrs.data || (this.$attrs.data.value !== undefined && this.$attrs.data.value === null)) {
        return [];
      }

      // Handles data mappingFrom, modifiedObject, mappingTo
      if (this.$attrs.data.value && this.$attrs.data.value['objectType']) {
        return [
          {
            node: {
              id: this.$attrs.data.value['objectType'] + ':' + this.$attrs.data.value['dbId'],
              title: {
                value: this.$attrs.data.value['title'] + '-' + this.$attrs.data.value['dbId'],
              },
            },
          },
        ];
      }

      // Handles data for related objects
      if (this.$attrs.data.value) {
        return this.$attrs.data.value['edges'] ? this.$attrs.data.value.edges : [{ node: this.$attrs.data.value }];
      }

      // Handles data for mapped objects
      return this.$attrs.data['edges'] ? this.$attrs.data.edges : [{ node: this.$attrs.data }];
    },
  },
});
